import { h } from "omi";

export function CountryNGIcon() {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#a)">
        <path
          d="M10 20c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C4.4771 0 0 4.4771 0 10c0 5.5228 4.4771 10 10 10Z"
          fill="#F0F0F0"
        />
        <path
          d="M-.0002 10c0 4.2997 2.7137 7.9651 6.5217 9.3781V.6221C2.7135 2.035-.0002 5.7004-.0002 10ZM20 10c0-4.2996-2.7137-7.965-6.5217-9.378v18.7561C17.2863 17.9651 20 14.2997 20 10Z"
          fill="#6DA544"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
